import { connect } from "react-redux";
import { getAttendanceSummary } from "../../../../redux/overview/overviewState";
import HeaderComponent from "components/card/HeaderComponent";
import BarChartBase from "components/charts/BarChartBase";

const WeeklyAttendanceOverview = ( props ) => {
  const { } = props;
  const data = [
    { day: "Mon", Present: 0, Absent: 0 },
    { day: "Tue", Present: 0, Absent: 0 },
    { day: "Wed", Present: 0, Absent: 0 },
    { day: "Thu", Present: 0, Absent: 0 },
    { day: "Fri", Present: 0, Absent: 0 },
  ];

  return (
      <HeaderComponent
        title="Weekly Attendance Overview"
        description="Present vs Absent employees this week"
      >
          <BarChartBase
            data={data}
            xKey="day"
            height={330}
            yKeys={["Present", "Absent"]}
            barColors={["#8b5cf6", "#a78bfa"]}
          />
      </HeaderComponent>
 
  );
};
export default WeeklyAttendanceOverview;